module.exports = __webpack_public_path__ + "static/media/cing_fang_andrea_shih.f090fc99.jpg";